<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('payment_and_checkout') }}
  div.text-sm.font-normal.basic600--text {{ $t('payment_and_checkout_desc') }}

  v-row.mt-8(no-gutters)
    v-col(cols="12" sm="7")
      div.d-flex
        div.pr-2
          div.text-md.font-medium.basic700--text {{ $t('accepting_payment') }}
          div.text-md.font-normal.basic600--text {{ $t('accepting_payment_desc') }}
        v-spacer
        div
          y-switch.mt-1.mb-n3.pa-0(v-model="acceptPayment")
      v-divider.basic300.my-4

      div.text-md.font-medium.basic700--text {{ $t('thank_you_message') }}
      div.text-md.font-normal.basic600--text {{ $t('thank_you_message_desc') }}
      yc-text-area.mt-4(:label="$t('message_template')" v-model="thankYouMessage")

      div.heading-6.basic700--text.mt-4 {{ $t('message_preview') }}
      v-card.message-preview-border.text-center.pa-4.mt-4(outlined)
        v-row(no-gutters justify="center")
          v-col(cols="12" sm="6")
            div.h6.basic700--text {{ thankYouMessage || $t('thank_you_message_template.top') }}
            div.p1.basic700--text.mt-4 {{ $t('thank_you_message_template.middle') }}
            div.p1.basic700--text.mt-4 {{ $t('thank_you_message_template.bottom') }}


  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(color="info500" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SettingsPaymentCheckout',
  data () {
    return {
      isLoading: false,
      acceptPayment: false,
      thankYouMessage: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
  },
  mounted () {
    this.setData(this.campaign)
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (campaign) {
      if (campaign.payment_enabled) {
        this.acceptPayment = campaign.payment_enabled
      }
      if (campaign.form.message_template) {
        this.thankYouMessage = campaign.form.message_template
      }
    },
    saveData () {
      this.isLoading = true
      let data = {
        payment_enabled: this.acceptPayment,
        form: {
          message_template: this.thankYouMessage ? this.thankYouMessage : null
        }
      }
      this.$axios.patch(`/donations/${this.company.slug}/campaigns/${this.campaign.form.slug}`, data)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }

}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "thank_you_message_template": {
      "top": "Thank you for your donation!",
      "middle": "Donation #229",
      "bottom": "View and save the full receipt for your reference. Please check your SMS or email for your receipt copy."
    }
  },
  "id": {

  }
}
</i18n>